<div
  class="display-group-criteria"
  [ngClass]="{ 'larger-display': isAddGroup }"
>
  <p>GROUP CRITERIA</p>
  <student-sort-filters-display
    [columns]="columns"
    [studentSortFilters]="{ filterColumns: filters }"
    [showDeleteBtn]="!isSharedWithMe"
    [isGroupCriteria]="true"
    (clickedDelete)="deleteCriteria.emit($event)"
  ></student-sort-filters-display>
  <p *ngIf="!filters || (filters && filters.length == 0)">
    No criteria are set
  </p>
</div>
